// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2923":"css/app.6636","8436":"css/admin-app.6636"}[chunkId] + ".css";
};